(function organizationalUnitModifyControllerDefinition() {
    'use strict';

    angular.module('OrganizationalUnit')
        .controller('OrganizationalUnitModifyController', [
            '$scope', 'config', '$state', '$translate', '$stateParams', 'errorsExtend', 'adminOrganizationalUnitService', 'authExtend', 'themeService', 'storageTypeService', 'ui', '$interval', 'login', 'organizationalUnitConfigService', '$q', 'securityLevelConfigService', '$filter', 'alerts', 'Upload',
            function organizationalUnitModifyController($scope, config, $state, $translate, $stateParams, errors, adminOrganizationalUnitService, authExtend, themeService, storageTypeService, ui, $interval, login, organizationalUnitConfigService, $q, securityLevelConfigService, $filter, alerts, Upload) {
                $scope.hideDependOuDrop = true;
                $scope.securityLevelAccordionOpened = true;

                $scope.openSecurityLevelAccordion = function () {
                    $scope.securityLevelAccordionOpened = !$scope.securityLevelAccordionOpened;
                };

                // mapea un OrganizationalUnitConfigMetadata a un value.
                var mapOuConfigMetadataToValue = function (ouConfig, ouConfigMetadata) {

                    var optionsObject = ouConfigMetadata.metadata.properties.find(function (prop) {
                        return prop.property.name === 'options';
                    });

                    var metadataOptions = (optionsObject) ? optionsObject.value : null;

                    return {
                        idObject: ouConfig.id + '' + ouConfigMetadata.metadata.id,
                        metadataId: ouConfigMetadata.metadata.id,
                        metadataIsRequired: ouConfigMetadata.isRequired,
                        metadataIsUnique: ouConfigMetadata.isUnique,
                        metadataValue: '',
                        metadataType: ouConfigMetadata.metadata.metadataType.name,
                        metadataLabel: ouConfigMetadata.metadata.name,
                        metadataOptions: metadataOptions,
                        metadataPosition: ouConfigMetadata.position,
                        // utilizado para reconstruir el valor
                        organizationalUnitConfigMetadata: ouConfigMetadata
                    }
                };

                // Transforma los valores de metadato de usuario a lo que requiere la UI
                var ouOuConfigMetadataValueToUiValue = function (ou) {

                    angular.forEach(ou.configs, function (ouOuConfig) {

                        // armo un diccionario con los valores que tiene el usuario para sus metadatos
                        var metadataValues = {};

                        angular.forEach(ouOuConfig.metadataValues, function (ouOuConfigMetadataValue) {
                            metadataValues[ouOuConfigMetadataValue.organizationalUnitConfigMetadata.id] = ouOuConfigMetadataValue;
                        });

                        ouOuConfig.metadataValues = ouOuConfig.organizationalUnitConfig.metadata.map(function (ouConfigMetadata) {
                            var value = mapOuConfigMetadataToValue(ouOuConfig.organizationalUnitConfig, ouConfigMetadata);

                            value.originalValueObject = metadataValues[ouConfigMetadata.id];

                            if (value.originalValueObject)
                                value.metadataValue = value.originalValueObject.value;

                            return value;
                        });

                        ouOuConfig.metadataValues.sort(function (a, b) {
                            return a.metadataPosition - b.metadataPosition;
                        });
                    });
                };

                var ouOuConfigMetadataValueFromUiValue = function (ou) {

                    angular.forEach(ou.configs, function (ouOuConfig) {

                        ouOuConfig.metadataValues = ouOuConfig.metadataValues.map(function (ouMetadata) {
                            if (ouMetadata.originalValueObject) {
                                ouMetadata.originalValueObject.value = ouMetadata.metadataValue;
                                return ouMetadata.originalValueObject;
                            }
                            // si no tiene objeto original entonces hay que crearlo
                            return {
                                // es un ouOuConfigMetadataValue
                                value: ouMetadata.metadataValue,
                                organizationalUnitConfigMetadata: ouMetadata.organizationalUnitConfigMetadata
                            };
                        });
                    });
                };

                var backTheme,
                    fileUploadInfo = null,
                    fileStartImageInfo = null;

                var resetFileUpload = function resetFileUploadFn() {
                    fileUploadInfo = $scope.fileUploadInfo = {
                        loadedFile: null,
                        selectedFile: null,
                        promise: null,
                        progress: -1
                    };
                };

                var resetfileStartImageInfo = function resetfileStartImageInfoFn() {
                    fileStartImageInfo = $scope.fileStartImageInfo = {
                        loadedFile: null,
                        selectedFile: null,
                        promise: null,
                        progress: -1
                    };
                };

                $scope.loadStorageType = function () {
                    if ($scope.ou.parentOrganizationalUnitId > 0) {
                        adminOrganizationalUnitService.getById($scope.ou.parentOrganizationalUnitId)
                            .then(function (ou) {
                                $scope.ou.isRoot = false;
                                $scope.ou.storageTypeId = ou.storageTypeId;
                            }, function (error) {
                                errors.showError(error);
                            });

                    } else {
                        $scope.ou.isRoot = true;
                    }
                };

                $scope.loadImages = function () {
                    if ($stateParams.id) {
                        adminOrganizationalUnitService.getImagesById($stateParams.id).then(function (result) {
                            if (result) {
                                var logo = $filter('filter')(result, { isLogo: true }, true)[0];
                                fileUploadInfo.loadedFile = logo !== undefined ? 'data:image/jpeg;base64,' + logo.base64File : undefined;

                                if (logo !== undefined) {
                                    fileUploadInfo.selectedFile = new File([logo.base64File], logo.fileName, { type: "image/jpeg" });
                                }

                                var startImage = $filter('filter')(result, { isLogo: false }, true)[0];
                                fileStartImageInfo.loadedFile = startImage !== undefined ? 'data:image/jpeg;base64,' + startImage.base64File : undefined;

                                if (startImage !== undefined) {
                                    fileStartImageInfo.selectedFile = new File([startImage.base64File], startImage.fileName, { type: "image/jpeg" });
                                }
                            } else {
                                errors.showError('NotFound');
                                $state.go('organizational-unit-find');
                            }
                        }, function (error) {
                            errors.showError(error);
                            $state.go('organizational-unit-find');
                        });
                    }
                };

                // cargará los tipos asignables 
                $scope.getAssignableConfigs = function () {

                    organizationalUnitConfigService.getAll(true, $scope.ou.id, $scope.ou.parentOrganizationalUnitId)
                        .then(function (ous) {

                            $scope.aux.optionsOuConfigs = ous;

                            // agrego los ou configs actuales a los seleccionados
                            $scope.aux.selectedOuConfigs = $scope.aux.optionsOuConfigs.filter(function (config) {
                                return ($scope.ou.configs.findIndex(function (ouOuConfig) {
                                    return ouOuConfig.organizationalUnitConfig.id === config.id;
                                }) !== -1);
                            });

                        }, function (error) {
                            errors.showError(error);
                            $scope.cancel();
                        });
                };

                $scope.load = function () {
                    $scope.typedLength = 0;
                    $scope.fileReaderSupported = window.FileReader !== undefined && window.FileReader !== null && (window.FileAPI === null || window.FileAPI === undefined || window.FileAPI.html5 !== false);

                    $translate(['OUModify']).then(function (translated) {
                        $scope.title = translated.OUModify;
                    });

                    $scope.ou = {
                        name: '',
                        parentOrganizationalUnitId: '',
                        parentOrganizationalUnitName: '',
                        configs: []
                    };

                    $scope.myOu = ($stateParams.id === authExtend.getOrganizationId());
                    $scope.requiredOu = !$scope.myOu && authExtend.getOrganizationId() ? true : false;
                    $scope.IsUpdate = true;

                    securityLevelConfigService.get()
                        .then(function (slcs) {
                            $scope.aux.optionsSelectLevelConfig = slcs;
                        }, function (error) {
                            errors.showError(error);
                            $scope.cancel();
                        });


                    $scope.parameters = {
                        notInOuId: $stateParams.id
                    };

                    $scope.aux = {
                        optionsThemes: [],
                        selectedOuConfigs: [],
                        optionsOuConfigs: []
                    };

                    var ouPromise = adminOrganizationalUnitService.getById($stateParams.id, true);

                    var themePromise = themeService.get();

                    $scope.$watch("ou.parentOrganizationalUnitId", $scope.loadStorageType());
                    storageTypeService.get(null, null).then(function (result) {
                        $scope.aux.optionsStorageTypes = result;

                        $scope.showStorageTypes = true;
                    }, function (error) {
                        errors.showError(error);
                        $scope.cancel();
                    });

                    $q.all([ouPromise, themePromise])
                        .then(function (results) {

                            $scope.ou = results[0];
                            $scope.aux.optionsThemes = results[1];

                            $scope.ou.selectedSecurityLevel = $scope.ou.securityLevelConfig.id;

                            ouOuConfigMetadataValueToUiValue($scope.ou);

                            $scope.getAssignableConfigs();

                        }, function (error) {
                            errors.showError(error);
                            $scope.cancel();
                        });

                    resetFileUpload();
                    resetfileStartImageInfo();

                    $scope.loadImages();
                };

                // Mapeo los metadatos para que los entiendan los controles
                $scope.addOuConfig = function (ouConfig) {
                    var config = {
                        metadataValues: ouConfig.metadata.map(function (ouConfigMetadata) {
                            return mapOuConfigMetadataToValue(ouConfig, ouConfigMetadata);
                        }),
                        organizationalUnitConfig: ouConfig
                    };

                    config.metadataValues.sort(function (a, b) {
                        return a.metadataPosition - b.metadataPosition
                    });

                    $scope.ou.configs.push(config);
                };

                $scope.selectOuConfig = function (ouConfig) {
                    organizationalUnitConfigService.getById(ouConfig.id)
                        .then(function (result) {
                            $scope.addOuConfig(result);
                        }, function (error) {
                            errors.showError(error);
                            $scope.cancel();
                        });
                };

                $scope.removeOuConfig = function (ouConfig) {

                    var indexOf = $scope.ou.configs.findIndex(function (config) {
                        return (config.organizationalUnitConfig.id === ouConfig.id);
                    });

                    if (indexOf !== -1) {
                        $scope.ou.configs.splice(indexOf, 1);
                    }
                };

                $scope.removeStartImage = function () {
                    $scope.ou.urlStartImage = null;
                    resetfileStartImageInfo();
                };

                $scope.removeIcon = function () {
                    $scope.ou.urlIcon = null;
                    resetFileUpload();
                };

                $scope.onFileSelect = function onFileSelect(files) {
                    if (files && files.length && files[0].type.indexOf('image') > -1) {

                        if (fileUploadInfo.promise !== null) {
                            fileUploadInfo.promise.abort();
                            fileUploadInfo.promise = null;
                        }

                        fileUploadInfo.progress = -1;

                        // me interesa solo un archivo
                        fileUploadInfo.selectedFile = Upload.rename(files[0], 'logo_' + files[0].name);

                        if ($scope.fileReaderSupported) {

                            var fileReader = new FileReader();

                            fileReader.readAsDataURL(files[0]);

                            fileReader.onload = function (e) {
                                $scope.$apply(function () {
                                    fileUploadInfo.loadedFile = e.target.result;
                                });
                            };
                        }
                    }
                };

                $scope.onFileStartImageSelect = function startImageSelect(files) {
                    if (files && files.length && files[0].type.indexOf('image') > -1) {

                        if (fileStartImageInfo.promise !== null) {
                            fileStartImageInfo.promise.abort();
                            fileStartImageInfo.promise = null;
                        }
                        fileStartImageInfo.progress = -1;

                        // me interesa solo un archivo
                        fileStartImageInfo.selectedFile = Upload.rename(files[0], 'startImage_' + files[0].name);

                        if ($scope.fileReaderSupported) {

                            var fileReader = new FileReader();

                            fileReader.readAsDataURL(files[0]);

                            fileReader.onload = function (e) {
                                $scope.$apply(function () {
                                    fileStartImageInfo.loadedFile = e.target.result;
                                });
                            };
                        }
                    }
                };

                $scope.refresh = function () {
                    if ($scope.myOu) {
                        // si se modica mi ou 
                        authExtend.refreshToken()
                            .then(function (result) {
                                if (!result) {
                                    login.logOut();
                                    return;
                                }
                            },
                                function () {
                                    login.logOut();
                                });
                    }
                }

                $scope.save = function save() {
                    var startImage = false,
                        iconImage = false;

                    if (!$scope.organizationalUnitForm.$valid) {
                        errors.showError('VerifyFormData');
                        return false;
                    }

                    if (fileUploadInfo.promise !== null) {
                        fileUploadInfo.promise.abort();
                        fileUploadInfo.promise = null;
                    }

                    var auxFiles = [];
                    if (fileUploadInfo.selectedFile) {
                        auxFiles.push(fileUploadInfo.selectedFile);
                        iconImage = true;
                    }

                    if (fileStartImageInfo.promise !== null) {
                        fileStartImageInfo.promise.abort();
                        fileStartImageInfo.promise = null;
                    }

                    if (fileStartImageInfo.selectedFile) {
                        auxFiles.push(fileStartImageInfo.selectedFile);
                        startImage = true;
                    }

                    $scope.ou.securityLevelConfig = $filter('filter')($scope.aux.optionsSelectLevelConfig, { id: $scope.ou.selectedSecurityLevel }, true)[0];

                    var ou = angular.copy($scope.ou);

                    ouOuConfigMetadataValueFromUiValue(ou);

                    var modify = function () {
                        return adminOrganizationalUnitService.modify(ou, auxFiles, iconImage, startImage)
                            .then(function () {
                                $scope.refresh();
                                $state.go('organizational-unit-find');
                            },
                                function (error) {
                                    errors.showError(error);
                                });
                    };

                    modify();
                };

                $scope.updateParents = function (typed) {
                    var typedLength = String(typed).length;
                    if (Math.abs($scope.typedLength - typedLength) === 1) {
                        $scope.typedLength = typedLength;
                        if (typedLength !== 3) {
                            return;
                        }
                    } else {
                        $scope.typedLength = typedLength;
                        if (typedLength < 3) {
                            return;
                        }
                    }

                    adminOrganizationalUnitService.getNotInTree($stateParams.id, typed).then(function getOk(result) {
                        $scope.parents = result;
                    }, function getError(error) {
                        errors.showError(error);
                    });
                };

                $scope.previewTheme = function () {
                    var theme = null;

                    for (var i = 0; $scope.aux.optionsThemes.length > i; i++) {
                        if ($scope.aux.optionsThemes[i].id === $scope.ou.themeId) {
                            theme = $scope.aux.optionsThemes[i].path;
                        }
                    }

                    if (angular.isDefined(backTheme)) {
                        $interval.cancel(backTheme);
                    }

                    backTheme = $interval(function () {
                        ui.setTheme(authExtend.getTheme());
                        $interval.cancel(backTheme);
                    }, 1500);

                    ui.setTheme(theme);
                }

                $scope.cancel = function () {
                    $state.goBack('organizational-unit-find');
                };

                $scope.load();
            }
        ]);
})();
